import { render, staticRenderFns } from "./mass-update-email.vue?vue&type=template&id=b4b5d428&"
import script from "./mass-update-email.vue?vue&type=script&lang=js&"
export * from "./mass-update-email.vue?vue&type=script&lang=js&"
import style0 from "./mass-update-email.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports